<template>
  <div
    :class="[
      'phone-input',
      'transition-input',
      disabled && 'disabled',
      error && 'error',
    ]"
  >
    <MazPhoneNumberInput
      v-model="number"
      :id="id"
      :noValidation="true"
      :noExample="true"
      :fetchCountry="fetchCountry"
      :default-country-code="countryCode"
      :translations="{
        countrySelectorLabel: areaLabel,
        phoneNumberLabel: label,
      }"
      :disabled="disabled"
      class="text-input"
      @update="onUpdate"
      @focus="onFocus"
      @blur="onBlur"
    />
    <InputError :error="error" />
  </div>
</template>

<style lang="scss">
.phone-input {
  button[title="clear"] {
    display: none;
  }
  .input-error {
    margin-left: rem(153px);
  }

  &.error {
    .maz-phone-number-input {
      .maz-input__input {
        @include setColor(--color-status-error, border-color, true);
      }
    }
  }

  .maz-phone-number-input {
    .maz-select {
      label {
        font-size: rem(12px);
        left: rem(40px);
        margin-left: 0;
      }
    }
  }

  .maz-phone-number-input {
    .maz-input {
      height: rem(54px);
      border-radius: rem(6px) !important;
    }

    label {
      position: absolute !important;
      left: 0;
      top: rem(6px);
      font-size: rem(12px);
      @include setColor(--color-inactive, color, true);
    }

    .maz-input__input {
      height: inherit;
      border: 1px solid map-get($colors, --color-divider) !important;
      border: 1px solid var(--color-divider) !important;
      border-radius: rem(4px) !important;
    }

    .country-selector {
      margin-right: rem(15px);
      flex: 0 0 rem(153px);
      width: rem(153px);
      min-width: rem(153px);
      max-width: rem(153px);
      position: relative;
      height: rem(54px);

      .maz-input__input {
        padding-top: 8px !important;
        height: 100%;
      }

      .maz-select__toggle {
        height: auto;

        .maz-select__toggle__arrow {
          path.arrow {
            @include setColor(--color-cta, fill);
          }
        }
      }

      .country-selector__list {
        @include setColor(--color-bakground1, background-color);
      }

      .country-selector__input {
        border: 1px solid map-get($colors, --color-divider) !important;
        border: 1px solid var(--color-divider) !important;
        border-radius: rem(4px);
      }

      &.is-focused {
        .country-selector__input {
          @include setColor(--color-selection, caret-color, true);
          box-shadow: inherit !important;
        }
      }
    }

    .input-phone-number {
      .maz-input__input {
        padding: rem(0 0 0 15px);
        height: 100%;
      }

      &.has-value {
        .maz-input__input {
          padding: rem(8px 0 0 15px);
        }
      }

      &.is-focused {
        .maz-input__input {
          @include setColor(--color-selection, caret-color, true);
          box-shadow: inherit !important;
        }
      }
    }

    .country-selector,
    .input-tel__input,
    .country-selector__input {
      height: rem(54px);
    }

    .maz-phone-number-input__country-flag {
      top: calc(50%);
      transform: translateY(-25%);
      background-color: transparent;
      bottom: unset;
      padding-bottom: 8px;
    }
  }
}
</style>

<script>
import { parsePhoneNumberFromString } from "libphonenumber-js";

import InputError from "../InputError/InputError";

import { MazPhoneNumberInput } from "maz-ui";

export default {
  components: {
    InputError,
    MazPhoneNumberInput,
  },

  data() {
    const phoneNumber = this.value && parsePhoneNumberFromString(this.value);
    const number = (phoneNumber && phoneNumber.nationalNumber) || "";

    return {
      number,
      countryCode: !this.value ? this.defaultCountryCode : phoneNumber.country,
    };
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    defaultCountryCode: {
      type: String,
      default: null,
    },
    areaLabel: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fetchCountry: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onUpdate(values) {
      this.$emit("update:value", values.e164 || "");
      this.$emit("is-valid", values.isValid || false);
    },

    onFocus() {
      this.$emit("focus");
    },

    onBlur() {
      this.$emit("blur");
    },
  },

  async mounted() {
    // Fix submit type for button..
    await this.$nextTick();
    const element = document.querySelector(
      `#${this.id} .maz-phone-number-input__country-flag`,
    );
    if (element) {
      element.type = "button";
    }

    // Fix keyboard for ios/android
    const input = document.querySelector(
      `#${this.id} .input-phone-number input`,
    );
    if (input) {
      input.setAttribute("inputmode", "tel");
    }
  },
};
</script>
